import { combineReducers } from "redux";

import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";

import common from "../features/admin/common/Slice";

const masters = combineReducers({
  country,
  state,
  city,
  pincode,
  common
});

export default masters;
